import { Cancel, CheckCircle, Error, NotInterested } from '@mui/icons-material'
import { Grid, Typography } from '@mui/material'
import React from 'react'

interface CheckInReviewItemProps {
  complete?: boolean
  disabled?: boolean
  label?: string
  warning?: boolean
}

export default function CheckInReviewItem({ complete, disabled, label, warning }: CheckInReviewItemProps) {
  const getIcon = (): React.ReactNode => {
    if (disabled) {
      return <NotInterested color='disabled' />
    } else if (complete) {
      return <CheckCircle color='success' />
    } else if (warning) {
      return <Error color='warning' />
    }

    return <Cancel color='error' />
  }

  return (
    <Grid item xs={12} container alignItems='center'>
      <Grid item xs='auto'>
        {getIcon()}
      </Grid>

      <Grid item xs={true}>
        <Typography>{label}</Typography>
      </Grid>
    </Grid>
  )
}
